import config from 'config/config'
import { CHF } from 'lib/utilities'
import React from 'react'
import { Table } from 'semantic-ui-react'
import ComponentPlaceholder from '../../Helper/ComponentPlaceholder'
import Fragment from 'react-dot-fragment'
import { I18n } from 'lib/i18n'

const style = {
  borderTopWidth: 0,
  paddingTop: 0,
  paddingBottom: 0,
}

const extraStyle = { ...style, opacity: 0.5 }

class DealerCart extends React.Component {
  basketProducts() {
    const { cart = {} } = this.props
    const { data = {} } = cart
    const { products: cartProducts = [] } = data
    return cartProducts.map((cartProduct = {}, index) => (
      <Fragment key={index}>
        <Table.Row verticalAlign="top">
          <Table.Cell style={style}>
            <nobr>{cartProduct.article_number}</nobr>
          </Table.Cell>
          <Table.Cell style={style} children={cartProduct.title_de} />
          <Table.Cell
            style={style}
            textAlign="right"
            children={`${cartProduct.quantity}x`}
          />
          <Table.Cell
            style={extraStyle}
            textAlign="right"
            children={'Listenpreis'}
          />
          <Table.Cell
            style={extraStyle}
            textAlign="right"
            children={CHF(Number(cartProduct.price))}
          />
          <Table.Cell
            style={extraStyle}
            textAlign="right"
            children={CHF(cartProduct.quantity * +cartProduct.price)}
          />
        </Table.Row>
        <Table.Row verticalAlign="top">
          <Table.Cell
            verticalAlign="top"
            style={style}
            children={
              cartProduct.kind === 'specialItem' &&
              !!cartProduct.special_item_kind &&
              I18n.t(
                `admin.product.specialitems.${cartProduct.special_item_kind}`
              )
            }
          />
          <Table.Cell
            colSpan={3}
            verticalAlign="top"
            textAlign="right"
            style={extraStyle}
            children={`-${cartProduct.discount_percent}%`}
          />
          <Table.Cell
            verticalAlign="top"
            textAlign="right"
            style={extraStyle}
            children={CHF(
              (-cartProduct.discount_percent * cartProduct.price) / 100
            )}
          />
          <Table.Cell
            verticalAlign="top"
            textAlign="right"
            style={extraStyle}
            children={CHF(
              ((-cartProduct.discount_percent * cartProduct.price) / 100) *
                cartProduct.quantity
            )}
          />
        </Table.Row>
        <Table.Row verticalAlign="top">
          <Table.Cell
            colSpan={5}
            verticalAlign="top"
            textAlign="right"
            style={style}
            children={CHF(+cartProduct.discounted_price)}
          />
          <Table.Cell
            verticalAlign="top"
            textAlign="right"
            style={style}
            children={CHF(+cartProduct.discounted_price * cartProduct.quantity)}
          />
        </Table.Row>
      </Fragment>
    ))
  }

  render() {
    const dark = config.theme.dark
    const { cart = {} } = this.props
    const { data = {} } = cart

    return !cart.id ? (
      <ComponentPlaceholder />
    ) : (
      <Table
        inverted={dark}
        compact
        size="small"
        selectable
        singleLine
        basic="very"
        className="spaced">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing>Art. Nr.</Table.HeaderCell>
            <Table.HeaderCell width="8">Produkt</Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign="right">
              Anzahl
            </Table.HeaderCell>
            <Table.HeaderCell />
            <Table.HeaderCell collapsing textAlign="right">
              Einzelpreis
            </Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign="right">
              Gesamtpreis
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body children={this.basketProducts()} />

        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan="5" textAlign="right">
              Summe Produkte
            </Table.Cell>
            <Table.Cell textAlign="right">{CHF(data.product_sum)}</Table.Cell>
          </Table.Row>
          {!!data.user_discount && (
            <Table.Row>
              <Table.Cell
                colSpan="5"
                textAlign="right"
                children={`Selbstabholer-Rabatt (${data.user_discount}%)`}
              />
              <Table.Cell textAlign="right">
                {CHF(data.user_discount_amount)}
              </Table.Cell>
            </Table.Row>
          )}
          {!!data.discount_code_code && (
            <Table.Row>
              <Table.Cell
                colSpan="5"
                textAlign="right"
                children={`Aktion ${data.discount_code_code} ${
                  data.discount_code_percent
                    ? `(${data.discount_code_percent}%)`
                    : ''
                }`}
              />
              <Table.Cell textAlign="right">
                {CHF(-data.discount_code_amount)}
              </Table.Cell>
            </Table.Row>
          )}
          <Table.Row>
            <Table.Cell colSpan="5" textAlign="right">
              Versandkosten
            </Table.Cell>
            <Table.Cell textAlign="right">{CHF(data.shipping)}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell colSpan="5" textAlign="right">
              Summe Netto
            </Table.Cell>
            <Table.Cell textAlign="right">{CHF(data.total_sum)}</Table.Cell>
          </Table.Row>{' '}
          <Table.Row className="unobtrusive">
            <Table.Cell colSpan="5" textAlign="right">
              MwSt.
            </Table.Cell>
            <Table.Cell textAlign="right">
              <strong>{CHF(data.total_vat)}</strong>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell colSpan="5" textAlign="right">
              <strong>Endsumme</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign="right">
              <strong>{CHF(data.total_sum_incl_vat)}</strong>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    )
  }
}

export default DealerCart



// WEBPACK FOOTER //
// ./src/components/admin/Carts/DealerCart/DealerCart.jsx